import { xcss, Box } from '@atlaskit/primitives';
import Heading from '@atlaskit/heading';
import { useInfo } from '../../../Flow/ConsentContextProvider';

const centeredContentStyles = xcss({
  textAlign: 'center',
});

const AppName = () => {
  const { client } = useInfo();
  return (
    <Box xcss={centeredContentStyles}>
      <Heading size="large">{client?.name}</Heading>
    </Box>
  );
};

export default AppName;
